import controller from './orderAndPay.controller';
import template from './orderAndPay.html';

const orderAndPayDetailsComponent = {
  restrict: 'E',
  template,
  controller
};

export default orderAndPayDetailsComponent;



/** WEBPACK FOOTER **
 ** ./client/app/components/services/orderAndPay/orderAndPay.component.js
 **/